/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mean_Bad_Martin_FondInputs */

const fr_mean_bad_martin_fond = /** @type {(inputs: Mean_Bad_Martin_FondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilité`)
};

/**

* @param {Mean_Bad_Martin_FondInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mean_bad_martin_fond = /** @type {((inputs?: Mean_Bad_Martin_FondInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mean_Bad_Martin_FondInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mean_bad_martin_fond(inputs)
});